import { suffixBaseURL } from '@/config/api'
import { httpClient } from '@/shared/infra/adapters/axios/axios'

export interface GetCompanyByAlphaIdParams {
  alphaId: string
}

export interface GetCompanyByAlphaIdResponse {
  alphaId: string
  companyTypeCode: string
  companyChainProfileData: unknown
  legalData: {
    taxpayerId: string
    corporateName: string
    name: string
    stateRegistration: string
    municipalRegistration: string
    observation: string
  }
  responsibleData: {
    name: string
    responsibleTaxpayerId: string
    companyPosition: string
  }
  contactData: {
    name: string
    companyEmail: string
    companyPhone: string
  }
  addressData: {
    address: string
    number: string
    complement: string
    city: string
    zipcode: string
    state: string
  }
  contracts: {
    b2bContract: string
    socialContract: string
    inheritedFrom: string
  }
}

export async function getCompanyByAlphaId({
  alphaId,
}: GetCompanyByAlphaIdParams) {
  const { data } = await httpClient.get<{
    data: GetCompanyByAlphaIdResponse[]
  }>(`${suffixBaseURL.myBusiness}/company-infos/${alphaId}`)

  if (!data || data.data.length === 0) {
    throw new Error('Company not found.')
  }

  return data.data[0]
}
